<template>
  <checkbox-input
    :id="value.id"
    v-model="isActive"
    class-label="filter-dropdown__checkbox-label text-body-m-regular"
    :disabled="!value.count"
    :label="label"
    :name="name"
    @change="handleFilter(value)"
  />
</template>

<script>

/**
 * Vue: Filter list value (filter-list-value)
 * -----------------------------------------------------------------------------
 * Component that houses filter input of the list type.
 *
 * @param {Array} activeFilters - Currently active filters.
 * @param {String} name - Filter id.
 * @param {Object} value - Singular filter input.
 *
 * @emits handleFilter - Emit filter update.
 *
 */
import CheckboxInput from '~async/utils/checkbox-input/checkbox-input'

export default {
  name: 'FilterListValue',

  components: {
    CheckboxInput,
  },

  props: {
    activeFilters: {
      type: Array,
      default: () => [],
      required: true,
    },
    name: {
      type: String,
      default: '',
      required: true,
    },
    value: {
      type: Object,
      default: () => ({}),
      required: true,
    },
  },

  emits: {
    'handle-filter': (payload) => typeof payload === 'object',
  },

  data() {
    return {
      isActive: false,
    }
  },

  computed: {

    /**
     * Compute label of the checkbox.
     * @returns {String}
     */
    label() {
      return `
        <span class="filter-dropdown__value-text text-body-s-regular">
          ${this.value.label}
        </span>

        <span class="filter-dropdown__count text-body-s-bold">
          (${this.value.count})
        </span>
      `
    },
  },

  watch: {

    /**
     * Watch active filters to check filter option.
     */
    activeFilters: {
      handler() {
        this.isActive = this.isChecked()
      },
      deep: true,
    },
  },

  mounted() {
    this.isActive = this.isChecked()
  },

  methods: {

    /**
     * Check if filter is checked.
     * @param {Object} filterValue - Filter value.
     * @returns {Boolean} - True if filter is checked.
     */
    isChecked() {
      if (!this.activeFilters) {
        return false
      }

      return this.activeFilters.some((filterInput) => {
        return JSON.stringify(this.value.input) === JSON.stringify(filterInput)
      })
    },

    /**
     * Handle filter (de)selection.
     * @param {Object} filter - Filter object.
     */
    handleFilter(filter) {
      this.$emit('handle-filter', filter)
    },
  },
}
</script>
